import { createContext } from "react";

const AlertContex = createContext();

export default AlertContex;